import { createFileRoute } from "@tanstack/react-router";
import { VerifyPage } from "@/projects/teacher/pages/VerifyPage";

export const Route = createFileRoute("/teacher/verify/$id")({
  head: () => ({ meta: [{ title: "Verify Submission — Teacher" }] }),
  component: VerifyPage,
});
